<div fxLayout="column" class="w-100-p">
    <div class="w-100-p mt-32" fxLayoutAlign="center start">
        <div fxFlex="50">
            <p class="p-0 m-0 font-size-36 line-height-36 mb-4">{{ "CREATE_USER" | translate }}</p>
            <p class="p-0 m-0 font-size-16 line-height-16">{{ "CREATE_USER_DESCRIPTION" | translate }}</p>
        </div>
    </div>
    <div fxLayoutAlign="center center" *ngIf="updateProfileImage">
        <div class="w-120">
            <div class="profile-image-container">
                <div class="user-profile-pic">
                    <div
                        [hidden]="profileImageFileUrl"
                        class="profile-image cursor-pointer"
                        (click)="openProfileImageDialog()"
                        [ngStyle]="{ 'background-image': 'url(' + profileDefaultImageUrl + ')' }"
                    ></div>
                    <div id="image" [hidden]="!profileImageFileUrl" class="profile-image cursor-pointer"></div>
                </div>

                <button mat-mini-fab color="primary" class="profile-add-icon-button" (click)="openProfileImageDialog()">
                    <mat-icon *ngIf="!profileImageFileUrl" aria-label="add">add</mat-icon>
                    <mat-icon *ngIf="profileImageFileUrl" aria-label="add">edit</mat-icon>
                </button>
            </div>
            <div>
                <p class="subtitle-1 text-center">{{ "UPDATE_PROFILE_IMAGE" | translate }}</p>
            </div>
        </div>
    </div>
    <div fxLayoutAlign="center start" class="w-100-p mt-32">
        <mat-card appearance="outlined" ngStyle.gt-sm="p-32" ngStyle.sm="p-16" ngStyle.xs="p-16" fxFlex="50">
            <form #formRef="ngForm">
                <div fxLayout="row" fxLayoutGap="24px" class="mb-24">
                    <div fxFlex="50">
                        <mat-form-field class="w-100-p" appearance="outline">
                            <mat-label>{{ "FIRST_NAME" | translate }}</mat-label>
                            <input
                                matInput
                                [(ngModel)]="userInfo.FirstName"
                                placeholder="First Name"
                                name="firstName"
                                #firstName="ngModel"
                                required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex="50">
                        <mat-form-field class="w-100-p" appearance="outline">
                            <mat-label>{{ "LAST_NAME" | translate }}</mat-label>
                            <input matInput [(ngModel)]="userInfo.LastName" name="lastName" placeholder="Last Name" />
                        </mat-form-field>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutGap="24px" class="mb-24">
                    <div fxFlex="50">
                        <mat-form-field class="w-100-p" appearance="outline">
                            <mat-label>{{ "SALUTATION" | translate }}</mat-label>
                            <mat-select
                                [(ngModel)]="userInfo.Salutation"
                                name="salutationField"
                                placeholder="Salutation"
                            >
                                <mat-option *ngFor="let sal of salutation" [value]="sal">
                                    {{ sal }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="50">
                        <mat-form-field class="w-100-p" appearance="outline">
                            <mat-label>{{ "GENDER" | translate }}</mat-label>

                            <mat-select [(ngModel)]="userInfo.Sex" name="genderField" placeholder="Gender">
                                <mat-option *ngFor="let sex of gender" [value]="sex">
                                    {{ sex }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutGap="24px" class="mb-24">
                    <div fxFlex="50">
                        <mat-form-field class="w-100-p" appearance="outline">
                            <mat-label>{{ "EMAIL" | translate }}</mat-label>
                            <input
                                matInput
                                [(ngModel)]="userInfo.Email"
                                (ngModelChange)="isEmailExist()"
                                placeholder="Email"
                                name="email"
                                #email="ngModel"
                                required
                            />
                        </mat-form-field>
                        <div class="error-msg error-msg-color" *ngIf="userInfo.Email && validEmail == false">
                            <span class="secondary-text-color-two p-0 mt-0">
                                {{ "APP_PLATFORM_USER_ACCESS_MANAGEMENT.EMAIL_INVALID" | translate }}
                            </span>
                        </div>
                        <div class="error-msg error-msg-color" *ngIf="userInfo.Email && emailAvailable == false">
                            <span class="secondary-text-color-two p-0 mt-0">
                                {{ "APP_PLATFORM_USER_ACCESS_MANAGEMENT.EMAIL_ALREADY_EXIST" | translate }}
                            </span>
                        </div>
                        <div class="error-msg error-msg-color" *ngIf="email.touched && !email.value">
                            <span class="secondary-text-color-two p-0 mt-0">
                                {{ "EMAIL_REQ" | translate }}
                            </span>
                        </div>
                        <!-- USE TRANSLATE -->
                    </div>
                    <div fxFlex="50">
                        <div fxLayout="column">
                            <div fxFlex="100" fxLayout="column" class="phone-outline mb-24">
                                <label class="phone-outline-label">{{ "PHONENUMBER" | translate }}</label>
                                <div fxFlex="100" class="phone-outline-box">
                                    <div fxFlex="100">
                                        <international-phone-number
                                            [(ngModel)]="userInfo.PhoneNumber"
                                            placeholder="Phone number"
                                            [maxlength]="20"
                                            [defaultCountry]="defaultCountryOfPhoneNumber"
                                            [required]="true"
                                            #phoneNumber="ngModel"
                                            name="phone_number"
                                        ></international-phone-number>
                                    </div>
                                </div>
                            </div>
                            <div
                                *ngIf="userInfo.PhoneNumber && !phoneNumber.valid"
                                class="error-msg error-msg-color help-block"
                            >
                                {{ "APP_PLATFORM_USER_ACCESS_MANAGEMENT.PHONENUMBER_INVALID" | translate }}
                            </div>
                            <div
                                *ngIf="phoneNumber.touched && !phoneNumber.value"
                                class="error-msg error-msg-color help-block"
                            >
                                {{ "PHONENUMBER_REQ" | translate }}
                            </div>
                            <!-- USE TRANSLATE -->
                        </div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutGap="24px" class="mb-24">
                    <div fxFlex="50">
                        <mat-form-field class="w-100-p" appearance="outline">
                            <mat-label>{{ "ROLE" | translate }}</mat-label>
                            <mat-select
                                [multiple]="isMultipleRole"
                                [(ngModel)]="seletedRole"
                                (selectionChange)="onSelectionChange($event)"
                                name="role"
                                placeholder="Role"
                                #role="ngModel"
                                required
                            >
                                <mat-option *ngFor="let role of roleList" [value]="role">
                                    {{ "ROLES." + role.RoleName | translate }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="error-msg error-msg-color" *ngIf="role.touched && !role.valid">
                            <span class="secondary-text-color-two p-0 mt-0">
                                {{ "ROLE_REQ" | translate }}
                            </span>
                        </div>
                    </div>
                    <div fxFlex="50">
                        <div fxLayout="row">
                            <mat-slide-toggle
                                color="primary"
                                [checked]="userInfo.TwoFactorEnabled"
                                (change)="setTwofactorAuthentication()"
                            >
                                <span class="subtitle-1">{{
                                    "APP_PLATFORM_USER_ACCESS_MANAGEMENT.ENABLE_TWO_FACTOR_AUTHENTICATION" | translate
                                }}</span>
                            </mat-slide-toggle>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <span></span>
                    <div>
                        <!-- [disabled]="loading || !email.valid || !phoneNumber.valid || !role.valid || !firstName.valid" -->
                        <!-- (click)="(email.valid && phoneNumber.valid && role.valid && firstName.valid && createuser())" -->
                        <button mat-raised-button (FormSubmitValidation)="createuser()" color="primary">
                            {{
                                "Create
            User"
                            }}
                        </button>
                    </div>
                </div>
            </form>
            <mat-progress-bar *ngIf="loading" color="primary" mode="indeterminate"></mat-progress-bar>
        </mat-card>
    </div>
</div>
